import React, { useState } from "react"
import PropTypes from "prop-types"
import { Link, useLocation } from "react-router-dom"
import { Row, Col, BreadcrumbItem } from "reactstrap"
import configure from "configure"
import Draggable from "react-draggable"
import { ResizableBox } from "react-resizable"
import Select from "react-select"
import { Label } from "reactstrap"
import VideoSection from "../../../src/pages/Help/VideoSection"
import "../../../src/assets/css/Settings/generalSetting.css"

const Breadcrumbs = ({ title, breadcrumbItem, englishVideo, hindiVideo }) => {
  const location = useLocation()
  const kPath = location.pathname
  const knowledgebaseUrl = `${configure.appUrl}knowledgebase`

  const [helpVideo, setHelpVideo] = useState(false)
  const [language, setLanguage] = useState("english")

  const onClose = () => {
    setHelpVideo(false)
  }

  const languageOptions = [
    { value: "english", label: "English" },
    { value: "hindi", label: "हिंदी" },
  ]

  React.useEffect(() => {
    const disableContextMenu = e => e.preventDefault()

    const disableKeys = e => {
      // Block F12, Ctrl+Shift+I, Ctrl+Shift+J, Ctrl+U
      if (
        e.key === "F12" ||
        // (e.ctrlKey && e.shiftKey && e.key === "I") ||
        (e.ctrlKey && e.shiftKey && e.key === "J") ||
        (e.ctrlKey && e.key === "U")
      ) {
        e.preventDefault()
        e.stopPropagation()
      }
    }

    if (helpVideo) {
      document.addEventListener("contextmenu", disableContextMenu)
      document.addEventListener("keydown", disableKeys)
    } else {
      document.removeEventListener("contextmenu", disableContextMenu)
      document.removeEventListener("keydown", disableKeys)
    }

    return () => {
      document.removeEventListener("contextmenu", disableContextMenu)
      document.removeEventListener("keydown", disableKeys)
    }
  }, [helpVideo])

  return (
    <>
      <Row>
        <Col className="col-12 p-0">
          <div className="page-title-box d-sm-flex align-items-center justify-content-between">
            {/* Left section: title + help */}
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <h4 className="mb-sm-0 font-size-18">
                {kPath === knowledgebaseUrl ? title : breadcrumbItem}
              </h4>
            </div>

            {/* Right section: breadcrumbs + help */}
            <div
              className="page-title-right "
              style={{ display: "flex", alignItems: "center", gap: "55px" }}
            >
              {/* Help section first */}
              {(englishVideo || hindiVideo) && (
                <span className="help-icon"
                  onClick={() => setHelpVideo(true)}
                  onMouseEnter={e => {
                    e.currentTarget.style.backgroundColor = "#5C0385"
                    e.currentTarget.style.color = "#ffffff"
                  }}
                  onMouseLeave={e => {
                    e.currentTarget.style.backgroundColor = "white"
                    e.currentTarget.style.color = "#5C0385"
                  }}
                >
                  <span>Help</span>
                  <i className="bi bi-camera-reels font-size-16" />
                </span>
              )}

              {/* Breadcrumbs after Help */}
              <ol className="breadcrumb m-0">
                {kPath === knowledgebaseUrl ? (
                  <>
                    <BreadcrumbItem>
                      <Link>{title}</Link>
                    </BreadcrumbItem>
                    <BreadcrumbItem active>
                      <Link to="#">{breadcrumbItem}</Link>
                    </BreadcrumbItem>
                  </>
                ) : (
                  <>
                    <BreadcrumbItem>
                      <Link to={`${configure.appUrl}`}>{title}</Link>
                    </BreadcrumbItem>
                    <BreadcrumbItem active>
                      <Link to="#">{breadcrumbItem}</Link>
                    </BreadcrumbItem>
                  </>
                )}
              </ol>
            </div>
          </div>
        </Col>
      </Row>

      {/* Help Video Modal */}
      {helpVideo && (
        <div className="note-sticky-form d-block">
          <Draggable handle=".modal-header" cancel=".modal-body">
            <ResizableBox
              width={750}
              style={{
                position: "absolute",
                top: "5%",
                right: "30%",
                zIndex: 999,
                backgroundColor: "#fff",
                maxHeight: "fit-content",
                transform: "translate(-50%, -50%)",
              }}
            >
              <div className="modal-header d-flex align-items-center justify-content-between">
                <h5 className="modal-title mt-0 mb-0">
                  {breadcrumbItem} - Help Video
                </h5>

                <div className="d-flex align-items-center gap-3">
                  <div
                    className="d-flex align-items-center gap-2"
                    style={{ minWidth: "220px" }}
                  >
                    <Label
                      className="mb-0 small"
                      style={{
                        fontSize: "12px",
                        lineHeight: "28px",
                        display: "inline-block",
                      }}
                    >
                      Change Language:
                    </Label>

                    <Select
                      className="w-40"
                      value={languageOptions.find(
                        opt => opt.value === language
                      )}
                      options={languageOptions}
                      onChange={opt => setLanguage(opt.value)}
                      styles={{
                        control: provided => ({
                          ...provided,
                          minHeight: "32px",
                          height: "32px",
                          fontSize: "14px",
                          borderRadius: "6px",
                          padding: "0 2px",
                        }),
                        valueContainer: provided => ({
                          ...provided,
                          height: "32px",
                          padding: "0 6px",
                        }),
                        indicatorsContainer: provided => ({
                          ...provided,
                          height: "32px",
                        }),
                        menu: provided => ({ ...provided, fontSize: "14px" }),
                      }}
                    />
                  </div>

                  <button
                    type="button"
                    onClick={() => setHelpVideo(false)}
                    className="btn-modal-close"
                  >
                    <span aria-hidden="true" className="btn-modal-span">
                      &times;
                    </span>
                  </button>
                </div>
              </div>

              <VideoSection
                onClose={onClose}
                language={language}
                englishVideo={englishVideo}
                hindiVideo={hindiVideo}
              />
            </ResizableBox>
          </Draggable>
        </div>
      )}
    </>
  )
}

Breadcrumbs.propTypes = {
  breadcrumbItem: PropTypes.string,
  title: PropTypes.string,
  englishVideo: PropTypes.string,
  hindiVideo: PropTypes.string,
}

export default Breadcrumbs
